<template>
  <div id="pers-tab3" name="hres32e-tab3" class="content-pers-table">
    <hrms-table :columns="detail3Table"
                :data="detail"
                :maxRowspan="maxRowspanDetail6"
                :addInlineEventBool="validateStaappr"
                :editInlineEventBool="validateStaappr"
                :deleteInlineEventBool="validateStaappr"
                :deleteInlineBtnDisp="false"
                :saveInlineBtnDisp="validateStaappr"
                :saveInlineEvent="callSave"
                :nowLang="nowLang" />

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import detailTemplate from 'components/hres32e/detailTemplate'

export default {
  name: 'hres32e-tab3',
  methods: {
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            p_codempid: this.indexSelected.codempid,
            p_dtereq: this.indexSelected.dtereq,
            p_numseq: this.indexSelected.numseq,
            p_codempid_query: this.indexSelected.codempid
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postDetail3Save({ saveParams: dataRowsHasFlg, searchIndex: this.searchIndex, togglePage: this.togglePage, indexSelected: this.indexSelected })
        }
      })
    }
  },
  props: [ 'nowLang',
    'labels',
    'detail',
    'pcDisp',
    'togglePage',
    'labelsButton',
    'deleteEducation',
    'dropdowns',
    'detail3Table',
    'postDetail3Save',
    'indexSelected',
    'searchIndex',
    'validateStaappr'
  ],
  components: {
    detailTemplate
  }
}
</script>



// WEBPACK FOOTER //
// tab3.vue?1dc9f5ff